import React from 'react'

import FirstSection from './FirstSection'
import SecondSection from './SecondSection'
import ThirthSection from './ThirthSection'
import FourthSection from './FourthSection'
import VideoSection from './VideoSection'

import ColorPallet from '../../../utils/ColorPallet'

function MainSection() {
  return (
    <div className='min-h-screen'>
      {/* First Section */}
      <FirstSection />
      
      {/* Second Section */}
      <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <SecondSection />
      </div>

      {/* Third Section */}
      <div style={{ backgroundColor: ColorPallet.secondLightBrown }}>
        <ThirthSection />
      </div>
    
      {/* Third Section */}
      <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <FourthSection />
      </div>

      <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <VideoSection />
      </div>
    
    </div>
  )
}

export default MainSection